import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import AskSita from "@/components/AskSita";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import MealPrep from "@/pages/MealPrep";
import Feedback from "@/pages/Feedback";
import SupperClub from "@/pages/SupperClub";
import Catering from "@/pages/Catering";
import PrivateEvents from "@/pages/PrivateEvents";
import About from "@/pages/About";
import Inquiries from "@/pages/Inquiries";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream px-6 text-center">
          <div>
            <p className="font-display text-3xl italic text-forest">Something slipped in the kitchen.</p>
            <p className="mt-3 text-ink/70">Please refresh the page — we'll get the table reset.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <div className="grain flex min-h-screen flex-col bg-cream">
          <Nav />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/supper-club" element={<SupperClub />} />
              <Route path="/catering" element={<Catering />} />
              <Route path="/private-events" element={<PrivateEvents />} />
              <Route path="/about" element={<About />} />
              <Route path="/inquiries" element={<Inquiries />} />
              <Route path="/meal-prep" element={<MealPrep />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <AskSita />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
